import React from 'react';
import FoldableSection from './FoldableSection';
import TeacherCard, { Teacher } from './TeacherCard';

interface TeacherSelectionSectionProps {
    expanded: boolean;
    setExpanded: (expanded: boolean) => void;
    teachers: Teacher[];
    selectedTeacher: Teacher | null;
    setSelectedTeacher: (teacher: Teacher) => void;
    disabled?: boolean;
}

const TeacherSelectionSection: React.FC<TeacherSelectionSectionProps> = ({
    expanded,
    setExpanded,
    teachers,
    selectedTeacher,
    setSelectedTeacher,
    disabled = false
}) => {
    return (
        <FoldableSection
            title="Pilih Guru Anda"
            expanded={expanded}
            setExpanded={setExpanded}
            disabled={disabled}
            info={<span>{selectedTeacher?.name || 'Select a teacher'}</span>}
        >
            <div className="teachers-list">
                {teachers.map(teacher => (
                    <TeacherCard
                        key={teacher.id}
                        teacher={teacher}
                        selected={selectedTeacher?.id === teacher.id}
                        onClick={() => setSelectedTeacher(teacher)}
                        disabled={disabled}
                    />
                ))}
            </div>
        </FoldableSection>
    );
};

export default TeacherSelectionSection;